const prefix = '/storage';

export function getStorageFileUploadEndpoint(): string {
    return `${prefix}/upload`;
}

export function getStorageDirectFileUploadEndpoint(): string {
    return `${prefix}/direct-upload`;
}
